import { AnalyticsBrowser, type InitOptions, type AnalyticsBrowserSettings } from "@segment/analytics-next";
import { createContext } from "react";

export const SegmentContext = createContext<AnalyticsBrowser | undefined>(undefined);

export type SegmentContext = AnalyticsBrowser | undefined;

// eslint-disable-next-line react-refresh/only-export-components
export function createSegment(settings: AnalyticsBrowserSettings, config?: Partial<InitOptions>) {
    const analytics = AnalyticsBrowser.load(settings, config);
    return analytics;
}
